<template>
	<div class="root">
		<div class="date">
			{{date}}
		</div>
		<ClockDigit v-for="digit in clock" :digit="digit" />
	</div>
</template>

<script>
	import * as datefns from "date-fns";

	import ClockDigit from "./ClockDigit";

	export default {
		name: "TopRight",
		components: {
			ClockDigit
		},
		data: function () {
			return {
				now: new Date(),
				interval: null,
				date: "",
				clock: [],
			};
		},
		watch: {
			now: function (now) {
				this.date = datefns.format(now, "dddd, MMMM Do, YYYY");
				this.clock = datefns.format(now, "HH:mm:ss").split("");
			}
		},
		beforeMount() {
			this.interval = window.setInterval(this.tick, 250);
		},
		beforeDestroy() {
			window.clearInterval(this.interval);
		},
		methods: {
			tick() {
				this.now = new Date();
			},
		}
	}
</script>

<style scoped>
	.root {
		position: absolute;
		top: 42px;
		right: 42px;
		font-family: 'Roboto Mono', sans-serif;
		text-align: right;
		color: #ffffff;
		opacity: 0.8;
		z-index: 100;
	}

	.date {
		font-family: 'Helvetica', sans-serif;
		font-size: 22px;
	}
</style>
